// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"276":"b72eede1","920":"010cb22d"}[chunkId] + ".chunk.js";
};